const noteRound = (value) => {
    if (value === 10 || value === null) {
        return value;
    } else {
        return value.toFixed(1);
    }

}

const currencyRound = (value) => {
    if (value) {
        return value.toFixed(2);
    } else {
        return "";
    }

}

export {
    noteRound,
    currencyRound
}